// DevHub UI kit — canonical route path strings.
//
// A single source of truth for the app's in-app route paths, adopted across
// App.tsx, the Root sidebar, and the section/overview pages (~50 references).
// Enumerated from App.tsx (internal routes + admin subroutes) and the public
// shells (index.tsx / PublicApp.tsx / ExternalWorld.tsx). Grouped logically.

export const ROUTES = {
  // ── Home ──
  home: '/',

  // ── Section landing / overview pages ──
  overview: {
    catalog: '/catalog-overview',
    docs: '/docs-overview',
    resources: '/resources',
    community: '/community',
  },

  // ── Catalog ──
  catalog: {
    table: '/catalog',
    cards: '/catalog-cards',
    /** Legacy alias — the Curated Catalog page is retired; redirects to /landscape. */
    curated: '/catalog-curated',
    graph: '/catalog-graph',
    import: '/catalog-import',
  },

  // ── Docs (TechDocs) ──
  docs: {
    all: '/docs',
    curated: '/docs-curated',
    /** Bound to the techdocs:index-page routeRef — keep mounted. */
    index: '/docs-index',
  },

  // ── APIs ──
  api: {
    docs: '/api-docs',
    cards: '/api-docs-cards',
  },

  // ── Resources / tools ──
  resources: {
    landscape: '/landscape',
    mcpCatalog: '/mcp-catalog',
  },

  // ── Self Service (DevSecOps hub) ──
  selfService: {
    root: '/self-service',
    create: '/self-service/create',
  },

  // ── Misc top-level ──
  announcements: '/announcements',
  systemStatus: '/system-status',
  settings: '/settings',
  /** Legacy alias — redirects to /self-service/create. */
  create: '/create',

  // ── Admin (admin-only; sub-views are ?tab= inside their wrapper pages) ──
  admin: {
    root: '/admin',
    insights: '/admin/insights',
    curation: '/admin/curation',
    access: '/admin/access',
    resources: '/admin/resources',
  },

  // ── Public / partner world (unauthenticated shell) ──
  public: {
    products: '/products',
    contact: '/contact',
  },
} as const;
